const workSuggestions = {
  calm_low: [
    "Journal quietly for 5 minutes",
    "Organize your thoughts in a notes app",
    "Reflect on a recent win or lesson"
  ],
  calm_high: [
    "Start a creative project",
    "Outline a blog post or brainstorm ideas",
    "Work on a long-term goal"
  ],
  anxious_low: [
    "Do a 5-minute brain dump",
    "Give your workspace a light clean",
    "Take deep breaths and jot down your work worries"
  ],
  anxious_high: [
    "Tackle a simple, low-stakes task",
    "Organize your email inbox",
    "Sort your digital files or desktop"
  ],
  bored_medium: [
    "Try a productivity technique like Pomodoro",
    "Set a silly challenge (e.g. write 10 ideas in 5 minutes)",
    "Reorganize your workspace layout"
  ],
  restless_high: [
    "Do a standing task (like writing ideas on a whiteboard)",
    "Move while working (pace, stretch, stand)",
    "Do quick research for a fun side project"
  ],
  motivated_high: [
    "Start your most important task right away",
    "Work on something with a deadline",
    "Make progress on a passion project"
  ],
  default: [
    "Make a short to-do list",
    "Check your calendar or planner",
    "Spend 5 minutes making a plan"
  ]
};

export default workSuggestions;
